import { useEffect } from 'react'
import { Destructor, Listener, Listeners } from 'util/listener'

export type LockEvent = {
  lock: boolean
}

const listeners = new Listeners<LockEvent>()

export function addLockListener(listener: Listener<LockEvent>): Destructor {
  return listeners.add(listener)
}

export function removeLockListener(listener: Listener<LockEvent>): void {
  listeners.remove(listener)
}

let locks = 0
let unlock: Function | undefined
let timer: ReturnType<typeof setTimeout> | undefined

function lock() {
  const top = document.documentElement.scrollTop
  const left = document.documentElement.scrollLeft
  document.body.style.overflow = 'hidden'
  document.body.scrollTop = top
  document.body.scrollLeft = left
  listeners.fire({ lock: true })

  unlock = () => {
    document.body.style.overflow = ''
    document.documentElement.scrollTop = top
    document.documentElement.scrollLeft = left
    listeners.fire({ lock: false })
    unlock = undefined
  }
}

function sync() {
  timer = undefined
  const active = locks > 0
  if (active && !unlock) lock()
  else if (!active && unlock) unlock()
}

function schedule() {
  // deferred, so listeners are not fired during render
  // fix for https://reactjs.org/link/setstate-in-render
  if (timer === undefined) timer = setTimeout(sync)
}

export const useBodyScrollLock = (active: boolean): void => {
  useEffect(() => {
    if (!active) return

    ++locks
    schedule()

    return () => {
      --locks
      schedule()
    }
  }, [active])
}
